<template>
    <div class="container">
        <h1>Gestion des rôles pour référentiel</h1>
        <br>
        <div class="card flex">
            <input 
                @input="searchUser"
                v-model="searchString" 
                type="text" 
                placeholder="Ajouter un utilisateur" 
                class="p-inputtext-sm p-d-block p-mb-2"/>
            <!-- <AutoComplete v-model="searchString" optionLabel="email" :suggestions="usersWithoutAccess" @complete="searchUser"/> -->
        </div>
        <DataTable v-if="searchString" :value="filteredUsers || []" :paginator="false" dataKey="user_id">
            <Column field="editor" header="Créateur">
                <template #body="slotProps">
                    <input 
                        @change="toggleSelected(slotProps.data, 'RC', $event.target.checked)" 
                        :checked="checkAccessForUser(slotProps.data, 'RC')"
                        type="checkbox" />
                </template>
            </Column>
            <Column field="validator" header="Évaluateur">
                <template #body="slotProps">
                    <input 
                        @change="toggleSelected(slotProps.data, 'RE', $event.target.checked)" 
                        :checked="checkAccessForUser(slotProps.data, 'RE')"
                        type="checkbox" />
                </template>
            </Column>
            <Column field="name" header="Nom" :sortable="true" />
            <Column field="surname" header="Prénom" :sortable="true" />
            <Column field="username" header="Nom utilisateur" :sortable="true">
                <template #body="slotProps">
                    <span>{{ slotProps.data.username }}</span>
                    <i v-if="slotProps.data.admin === 1" class="bi bi-shield-fill" title="admin"></i>
                </template>
            </Column>
            <Column field="email" header="Email" :sortable="true" />
        </DataTable>
        <br>
        <br>
        <DataTable :value="usersWithAccess || []" :paginator="false" :rows="10" dataKey="user_id">
            <!-- Editeur de referentiels -->
            <Column field="editor" header="Créateur">
                <template #body="slotProps">
                    <input 
                        v-if="slotProps.data.admin !== 1"
                        @change="toggleSelected(slotProps.data, 'RC', $event.target.checked)" 
                        :checked="checkAccessForUser(slotProps.data, 'RC')"
                        type="checkbox" />
                </template>
            </Column>
            <!-- Validateur de référentiels -->
            <Column field="validator" header="Évaluateur">
                <template #body="slotProps">
                    <input 
                        v-if="slotProps.data.admin !== 1"
                        @change="toggleSelected(slotProps.data, 'RE', $event.target.checked)" 
                        :checked="checkAccessForUser(slotProps.data, 'RE')"
                        type="checkbox" />
                </template>
            </Column>
            <Column field="name" header="Nom" :sortable="true" />
            <Column field="surname" header="Prénom" :sortable="true" />
            <Column field="username" header="Nom utilisateur" :sortable="true">
                <template #body="slotProps">
                    <span>{{ slotProps.data.username }}</span>
                    <i v-if="slotProps.data.admin === 1" class="bi bi-shield-fill" title="admin"></i>
                </template>
            </Column>
            <Column field="email" header="Email" :sortable="true" />
        </DataTable>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
// import '../../assets/styles/user.css';
// import AutoComplete from 'primevue/autocomplete';

export default {
    name: "ReferentialAccess",
    components: {
        DataTable,
        Column,
        // AutoComplete,
    },
    data() {
        return {
            searchString: "",
            referentialId: null,
            referentialData: null,
            isReady: false,
            filteredUsers: [],
        };
    },
    computed: {
        ...mapState("referential", ["selectedReferential", "generalDataConfig", "userList", "userListRightsReferential"]),
        ...mapState("auth", ["isAdmin"]),
        ...mapGetters("referential", ["isReferentialLocked", "usersWithAccess", "usersWithoutAccess"]),
        /* isLocked() {
            
            const roles = this.$store.getters['referential/fetchReferential'](this.selectedReferential)
            if(!roles)this.isReferentialLocked(this.selectedReferential);
            if(roles &&(roles.status === "RELEASEUSED" || roles.status === "ARCHIVE") && (this.isAdmin || roles.RC)){
                //console.log("getters tu es dans la cond")
                return false;
            }else{
                return this.isReferentialLocked(this.selectedReferential)
            }   
        }, */
    },
    mounted() {
        //console.log("Entering ReferentialAccess component")
        //console.log("selectedReferential: ", this.selectedReferential)
        this.isReady = true
        this.isReady = true
        if(this.selectedReferential === 0) {
            if(this.$route.params.id) {
                this.$store.commit("referential/selectTreeMutation", this.$route.params.id)
            }
        } else {
            //console.log("Referential already loaded")
        }
        this.loadUsers().then(() => {
            //console.log("User list loaded", this.userList)
            //console.log("Selected users with access", this.usersWithAccess)
            //console.log("Selected users without access", this.usersWithoutAccess)
        }).catch((error) => {
            console.error("Error loading user list:", error)
        })
    },
    methods: {
        checkAccessForUser(user, type) {
            if(type === "RE") {
                return user.RE
            }
            if(type === "RC") {
                return user.RC
            }
            //console.log("We got no user yet, so we need to check what is inside user", user)
            return false
        },
        toggleSelected(user, type, checked) {
            //console.log(this.usersWithAccess)
            this.$store.dispatch("referential/toggleUserAccess", { user: user, referential_id: this.selectedReferential, type: type, checked: checked })
            .then(() => {
                this.searchUser()
            })
        },
        async loadUsers() {
            //console.log("loadUsers called")
            await this.$store.dispatch("referential/fetchUserList", this.selectedReferential)
                .then(() => {
                    //console.log("User list loaded", this.userList)
                    //console.log("User rights", this.userListRightsReferential)
                    //console.log("User rights", this.userListRightsReferential)
                })
                .catch((error) => {
                    console.error("Error loading user list:", error)
                })
        },
        searchUser() {
            setTimeout(() => {
                // //console.log("searchUser called with event: ", event)
                //console.log("searchString: ", this.searchString)
                if(!this.searchString.trim().length || this.searchString.trim().length <= 2) {
                    // this.filteredUsers.value = [...this.usersWithoutAccess]
                    this.filteredUsers = []
                    //console.log("No query, returning none")
                } else {
                    //console.log("Filtering users with query: ", this.searchString)
                    this.filteredUsers = this.usersWithoutAccess.filter((user) => {
                        return user.name.toLowerCase().includes(this.searchString.toLowerCase()) || user.surname.toLowerCase().includes(this.searchString.toLowerCase()) || user.email.toLowerCase().includes(this.searchString.toLowerCase()) || user.username.toLowerCase().includes(this.searchString.toLowerCase())
                    })
                    //console.log("Filtered users: ", this.filteredUsers)
                }
            }, 250)
        },
    },
};
</script>

<style scoped>
.container {
    padding: 2rem;
    background-color: var(--bg-color);
  }
  
  
  :deep(.p-datatable){
    border-radius: 8px;
  }
  
  :deep(.p-datatable-header-cell){
      padding: 5px 0px 12px 0;
      margin:5vh;
  }
  
  :deep(.p-datatable-tbody){
      padding-top: 15px;
  }
  
  :deep(.p-datatable-tbody > tr > td){
      padding: 12px 6px 10px 1px;
      border-bottom: 1px solid transparent !important;
      border-top: 1px solid transparent !important;
  }
  
  :deep(.p-datatable-tbody > tr){
      border: none !important;
  }
  
  :deep(.p-datatable-tbody > tr:hover) {
      background-color: var(--hover-bg);
      transition: all 0.3s ease;
  }
  
  :deep(.p-datatable-tbody > tr:hover > td) {
      border-bottom: 1px solid black !important;
      border-top: 1px solid black !important;
  }
  
  :deep(.p-datatable-thead > tr > th) {
      font-weight: 600;
  }
  
  input[type="checkbox"] {
    transform: scale(1.2);
    cursor: pointer;
  }
  
  .p-inputtext-sm {
    width: 100%;
    max-width: 800px;
    padding: 0.75rem;
    border-radius: 6px;
    border: 2px solid #dee2e6;
  }
  
  .card.flex {
      box-shadow: none;
  }
  
  .p-inputtext-sm:focus {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.25);
    border-radius: var(--border-radius);
  }
  
  :deep(.p-datatable-paginator-bottom){
      border: none;
      padding: 3vh 0 0 0;
  }
  
  :deep(.p-paginator-content){
      gap: 2vw;
      text-align:center;
  }
  .bi-shield-fill{
    color:var(--left3-color);
    margin-left: 0.3vw;
  }
</style>